module.exports = __webpack_public_path__ + "fonts/we-icons.woff2";